<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="location-search-tab">
    <div class="d-flex">
        <jhi-column-filter [request]="request" [resultSearch]="resultSearch" [filters]="filters" [eventName]="COLUMN_FILTER_EVENT_NAME"
                           class="flex-sm-grow-1"></jhi-column-filter>
    </div>
    <br/>
    <div class="row">
        <div class="col">
            <div class="mb-3 d-flex align-items-center">
                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                <div style="margin-left: 10px;">
                    <a href (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></a>
                </div>
                <span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="mb-3 d-flex justify-content-end">
                <button class="btn btn-outline-info" [routerLink]="['/', { outlets: { popup: 'location-edit-dialog' } }]" queryParamsHandling="merge"><i class="fa fa-asterisk fa-md" aria-hidden="true"></i> {{"new" | translate}}</button>
            </div>
        </div>
    </div>
    <div class="table-responsive" *ngIf="locations">
        <table class="table table-striped table-bordered table-curved" *ngIf="locations.length else nodata">
            <thead>
            <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
                <th [jhiSortBy]="ColumnLabels.LOCATION_NAME"><span jhiTranslate="crop-settings-manager.location.columns.location-name"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.ABBREVIATION"><span jhiTranslate="crop-settings-manager.location.columns.abbreviation"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.LOCATION_ID"><span jhiTranslate="crop-settings-manager.location.columns.location-id"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.COUNTRY"><span jhiTranslate="crop-settings-manager.location.columns.country"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.PARENT_LOC"><span jhiTranslate="crop-settings-manager.location.columns.parent-location"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.LATITUDE"><span jhiTranslate="crop-settings-manager.location.columns.latitude"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.LONGITUDE"><span jhiTranslate="crop-settings-manager.location.columns.longitude"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.ALTITUDE"><span jhiTranslate="crop-settings-manager.location.columns.altitude"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.TYPE"><span jhiTranslate="crop-settings-manager.location.columns.location-type"></span> <span class="fa fa-sort"></span></th>
                <th style="width: 95px;"><span jhiTranslate="crop-settings-manager.location.columns.action"></span></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let location of locations; trackBy: trackId; index as index">
                <td>{{location.name}}</td>
                <td>{{location.abbreviation}}</td>
                <td>{{location.id}}</td>
                <td>{{location.countryName}}</td>
                <td>{{location.parentLocName}}</td>
                <td>{{location.latitude}}</td>
                <td>{{location.longitude}}</td>
                <td>{{location.altitude}}</td>
                <td>{{location.locationTypeName}}</td>
                <td class="text-center" >
                    <button class="btn btn-sm btn-outline-info me-2" (click)="editLocation(location)" [disabled]="disableEdition(location)">
                        <i class="fa fa-edit fa-md" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-info me-2" (click)="deleteLocation(location)" [disabled]=disableDeletion(location.type)>
                        <i class="fa fa-trash fa-md" aria-hidden="true"></i>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
        <ng-template #nodata>
            <table class="table table-striped table-bordered table-curved">
                <thead>
                <tr>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td jhiTranslate="no.data"></td>
                </tr>
                </tbody>
            </table>
        </ng-template>
    </div>
    <div *ngIf="locations && locations.length">
        <div class="row">
            <div class="col">
                <div class="pagination-container">
                    <div class="pagination-box pagination-box-left">
                        <div>
                            <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                        </div>
                    </div>
                    <div class="pagination-box">
                        <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                        [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                    </div>
                    <div class="pagination-box pagination-box-right">
                        <div class="d-flex align-items-center">
                            <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                            <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="75">75</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
